export const PAYMENT_REQUIRED_EVENT = 'optioneer:payment-required'
export const PAYMENT_RECOVERY_PATH = '/settings?tab=subscription'

type AccessState = {
  access_status?: string
  can_access_app?: boolean
  upgrade_error_code?: string | null
}

export function requiresPaymentRecovery(status: AccessState | null | undefined): boolean {
  return (
    status?.can_access_app === false &&
    (status.access_status === 'premium_past_due' ||
      status.upgrade_error_code === 'PAYMENT_REQUIRED')
  )
}

export function paymentRecoveryDestination(returnTo: string): string {
  return `${PAYMENT_RECOVERY_PATH}&returnTo=${encodeURIComponent(returnTo)}`
}
